<template>
  <div class="tabs-view-container">
    <div class="tabs-wrapper">
      <div class="tabs-list" ref="scrollContainer" @wheel.prevent="handleScroll">
        <span
          v-for="tag in visitedViews"
          :key="tag.path"
          :class="isActive(tag) ? 'tag-item active' : 'tag-item'"
          @click="handleClick(tag)"
          @contextmenu.prevent="handleContextMenu($event, tag)"
        >
          <span class="tag-title">{{ tag.title }}</span>
          <span
            v-if="!isAffix(tag)"
            class="tag-close"
            @click.stop="handleClose(tag)"
          >
            <i class="el-icon-close"></i>
          </span>
        </span>
      </div>
      <div class="tabs-actions">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="action-btn">
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="closeOthers">关闭其他</el-dropdown-item>
            <el-dropdown-item command="closeAll">关闭所有</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TabsView',
  data() {
    return {
      affixTags: []
    }
  },
  computed: {
    ...mapState('tabs', {
      visitedViews: state => state.visitedViews
    })
  },
  watch: {
    $route() {
      // 首页不参与标签页
      if (this.$route.path !== '/main/home') {
        this.addView(this.$route)
      }
    }
  },
  mounted() {
    // 初始化时添加当前路由（首页不参与）
    if (this.$route.path !== '/main/home') {
      this.addView(this.$route)
    }
  },
  methods: {
    ...mapActions('tabs', ['addView', 'delView', 'delOthersViews', 'delAllViews']),
    isActive(tag) {
      return tag.path === this.$route.path
    },
    isAffix(tag) {
      // 首页不参与标签页，所以不需要固定标签
      return false
    },
    handleClick(tag) {
      if (tag.path === this.$route.path) return
      this.$router.push(tag.path)
    },
    handleClose(tag) {
      this.delView(tag).then(views => {
        if (this.isActive(tag)) {
          const latestView = views.slice(-1)[0]
          if (latestView) {
            this.$router.push(latestView.path)
          } else {
            // 如果没有其他标签，跳转到首页
            this.$router.push('/main/home')
          }
        }
      })
    },
    handleContextMenu(event, tag) {
      // 可以在这里添加右键菜单功能
    },
    handleCommand(command) {
      const currentTag = this.visitedViews.find(tag => tag.path === this.$route.path) || this.visitedViews[0]
      if (command === 'closeOthers') {
        this.delOthersViews(currentTag).then(() => {
          if (!this.isActive(currentTag)) {
            this.$router.push(currentTag.path)
          }
        })
      } else if (command === 'closeAll') {
        this.delAllViews().then(() => {
          // 关闭所有标签后，跳转到首页
          this.$router.push('/main/home')
        })
      }
    },
    handleScroll(e) {
      const scrollContainer = this.$refs.scrollContainer
      const eventDelta = e.wheelDelta || -e.deltaY * 40
      scrollContainer.scrollLeft = scrollContainer.scrollLeft + eventDelta / 4
    }
  }
}
</script>

<style scoped>
.tabs-view-container {
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  height: 40px;
}

.tabs-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 10px;
}

.tabs-list {
  flex: 1;
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  height: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.tabs-list::-webkit-scrollbar {
  display: none;
}

.tag-item {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  margin-right: 4px;
  height: 28px;
  line-height: 20px;
  font-size: 12px;
  color: #666;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.tag-item:hover {
  background: #e8e8e8;
}

.tag-item.active {
  color: #278cd8;
  background: #fff;
  border-color: #278cd8;
}

.tag-title {
  margin-right: 6px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tag-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  transition: all 0.3s;
}

.tag-close:hover {
  background: #c0c4cc;
  color: #fff;
}

.tabs-actions {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  cursor: pointer;
  color: #666;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  transition: all 0.3s;
}

.action-btn:hover {
  color: #278cd8;
  border-color: #278cd8;
  background: #f0f9ff;
}
</style>

